@if ((currentAction === 'move' || currentAction === 'atftobsk') && dialogMode === true) {
  <p-dialog
    [contentStyle]="{ overflow: 'auto', 'width': '75dvw', 'height': '80dvh' }"
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    (onHide)="close('validation')"
    >
    <ng-template pTemplate="header">
      <span class="p-dialog-title">
        {{'Bsk_Dest' | translate}}
      </span>
    </ng-template>
    @if (bskMode === true) {
      <div class="col-12">{{'Bsk_Ori' | translate}} {{ currentSelectedBsk.bskLabel }}</div>
    }
      @if (docId !== '' && actionGroup === false) {       
        <div class="flex flex-wrap h-full">
          <div class="flex-grow">
            <ng-container [ngTemplateOutlet]="BasketMoveList"></ng-container>
          </div>
          <div class="flex-grow">
            <atf-view
              [atfName]="atfName"
              [docId]="docId"
            ></atf-view>
          </div>
        </div>
      }@else {
        <ng-container [ngTemplateOutlet]="BasketMoveList"></ng-container>
      }
  </p-dialog>
}

@if (dialogMode === false) {
  <ng-container [ngTemplateOutlet]="BasketMoveListThumb"></ng-container>
}

<ng-template #BasketMoveList>
  @if (basketMoveAll.length !== 0) {
    <div class="col-12 scroll-table">
      <input
        (click)="$event.stopPropagation()"
        pInputText
        type="text"
        placeholder="{{'Filter' | translate}}"
        (input)="dt.filter($event.target.value, 'Information.Label', 'contains')"
        style="color: darkgrey;"
        />
        <p-table
          #dt
          [value]="basketMoveAll"
          [selectionMode]="'single'"
          responsiveLayout="stack"
          [breakpoint]="'960px'"
          (onRowSelect)="selectBasketTransfert($event)"
          >
          <ng-template let-bsk pTemplate="body">
            <tr
              class="img-hover colorbox-bsk"
              [className]="'class' + bsk.Information.color + ' colorbox-' + bsk.Information.basketType"
              [pSelectableRow]="bsk"
              >
              <td>
                <img src="{{ bsk.Information.url }}" width="35" />
              </td>
              <td>
                <div class="basket-info">
                  <i class="pi pi-question-circle md-24" pTooltip="{{ bsk.Information.Name }}" tooltipPosition="top">
                  </i>
                  @if (bsk.Information.Description !== '') {
                    <i
                      class="pi pi-info-circle md-24"
                      pTooltip="{{ bsk.Information.Description }}"
                      tooltipPosition="top"
                      >
                    </i>
                  }
                </div>
              </td>
              <td>
                <span>{{ bsk.Information.Label }}</span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">{{'Empty' | translate}}</td>
            </tr>
          </ng-template>
        </p-table>
    </div>
  }@else {
    <div class="col-12">
      {{'Bsk_Empty_3' | translate}}
    </div>
  }
  </ng-template>

  <ng-template #BasketMoveListThumb>
    @if (basketMoveAll.length !== 0) {
      <div class="col-12 scroll-table">
        <p-dataView
          [emptyMessage]="'Empty' | translate"
          #dv
          [value]="basketMoveAll"
          [paginator]="false"
          layout="grid"
          filterBy="Information.Label"
          >
          <ng-template pTemplate="header">
            <div class="filter">
              <i class="pi pi-search"></i>
              <input
                class="p-inputtext size_cent"
                placeholder="{{'Filter' | translate}}"
                pInputText
                type="search"
                (input)="dv.filter($event.target.value)"
                />
            </div>
          </ng-template>
            <ng-template let-baskets pTemplate="grid">
              <div class="grid pad-p">
                @for (bsk of baskets; track bsk) {
                  <div class="min-max-n border-st align cursorPointer m-1"
                    (click)="selectBasketTransfertImg(bsk)"
                    >
                    <div [className]="'class' + bsk.Information.color + ' colorbox-' + bsk.Information.basketType">
                      <img src="{{ bsk.Information.url }}" width="35"/>
                      <div class="text-size head border-st border-lr">
                        <div class="pad-6">{{ bsk.Information.Label }}</div>
                      </div>
                    </div>
                  </div>
                }
              </div>
          </ng-template>
        </p-dataView>
      </div>
    }@else {
      <div class="col-12">
        {{'Bsk_Empty_3' | translate}}
      </div>
    }
  </ng-template>
